import clock from './clock.svg';
import envelope from './envelope.svg';
import house from './house.svg';
import message from './message.svg';
import operatedBy from './operated-by.svg';
import people from './people.svg';
import pin from './pin.svg';
import phone from './phone.svg';
import star from './star.svg';

export { clock, envelope, house, message, operatedBy, people, pin, phone, star };
